import request from './api'

export async function getMaintenanceStatus() {
    try {
        const res = await request('/api/maintenance/status')
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}

export async function toggleMaintenance(action, duration = null) {
    try {
        const res = await request('/api/maintenance/toggle','POST',{action, duration})
        return {
            isOk: true,
            data: res
        }
    } catch (e) {
        return {
            isOk: false,
            message: e.message
        }
    }
}
